import {
  type IMediaLibDialogItem,
  MediaLibPresetEnum,
} from "@editor/modules/media-lib/types";
import { type ReactNode, createContext, useContext } from "react";

export interface IMediaLibDialogCtx {
  preset: MediaLibPresetEnum;
  isMultiSelect: boolean;
  isSingleSelect: boolean;
  canBulkActions: boolean;
  insertElementOnSelect: boolean;
  source: "default" | "settings";
  onSelect: (items: IMediaLibDialogItem) => void;
  onMultiSelect: (items: IMediaLibDialogItem[]) => void;
  closeDialog: () => void;
}

const initState: IMediaLibDialogCtx = {
  preset: MediaLibPresetEnum.All,
  isSingleSelect: false,
  isMultiSelect: false,
  canBulkActions: false,
  insertElementOnSelect: false,
  source: "default",
  onSelect: () => {},
  onMultiSelect: () => {},
  closeDialog: () => {},
};

export const MediaLibDialogCtx = createContext<IMediaLibDialogCtx>(initState);

interface IProps {
  children: ReactNode;
  ctxState: IMediaLibDialogCtx;
}

export const MediaLibDialogCtxProvider = ({ children, ctxState }: IProps) => {
  return (
    <MediaLibDialogCtx.Provider value={ctxState}>
      {children}
    </MediaLibDialogCtx.Provider>
  );
};

export const useMediaLibDialogCtx = () => {
  const ctx = useContext(MediaLibDialogCtx);
  if (!ctx)
    throw Error("useMediaLibDialogCtx: MediaLibDialogCtx is not defined!");
  return ctx;
};
